import Dropzone from '../../../../../assets/vendor/dropzone/dist/dropzone';

export default class Upload {
    constructor($field, $form) {
        this.$field = $field;
        this.$form = $form;
        this.$btnUpload = $field.querySelector('[data-upload-clickable]');
        this.$progress = $field.querySelector('[data-progress]');
        this.$progressLabel = $field.querySelector('[data-progress-label]');
        this.$progressbar = $field.querySelector('[data-progress-bar]');
        this.$fileList = $field.querySelector('[data-file-upload-names]');

        this.init = this.init.bind(this);
        this.uploadSuccess = this.uploadSuccess.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.updateRemoveFileListeners = this.updateRemoveFileListeners.bind(this);

        this.init();
        this.updateRemoveFileListeners();
    }

    updateRemoveFileListeners() {
        this.$field.querySelectorAll('[data-remove-file]').forEach($el => {
            $el.addEventListener('click', (e) => {
                this.removeFile( e, $el)
            })
        });
    }

    removeFile(e, $el) {
        e.preventDefault();
        let paramName = $el.dataset.removeFile;

        this.$fileList.innerHtml = '';

        this.$form.querySelector("[data-file='" + paramName + "']").remove();
        this.$form.querySelector("input[name='" + paramName + "[]']").remove();
        this.$form.querySelector("input[name='" + paramName + "-name[]']").remove();
    };

    uploadSuccess(fileName, response) {
        this.$progress.classList.remove('file-upload__progress--active');
        this.$form.querySelector('[data-submit]').classList.remove('button--disabled');

        // If we recieved an OK status
        if (response.status === 1) {
            // Remove error msg if any
            const error = this.$field.parentElement.parentElement.querySelector('.form__error');
            if(error) {
                error.remove();
            }

            // Add a hidden field to the form containing the given uploaded
            // file path, so we can store it properly upon form submit
            // show the original filename as preview
            this.$fileList.innerHTML = '' +
                    '<div class="file-upload__file" data-file="' + this.$field.dataset.paramName + '">'
                        + fileName +
                        '<a href="#" class="file-upload__delete" data-remove-file="' + this.$field.dataset.paramName + '">' +
                        '   <i class="icon-close"></i>' +
                        '</a>' +
                    '</div>';

            const child = document.createElement('div');
            child.innerHTML = '<input type="hidden" name="'+ this.$field.dataset.paramName +'[]" value="'+ response.data.filepath +'"/>';
            this.$form.appendChild(child);
            const child2 = document.createElement('div');
            child2.innerHTML = '<input type="hidden" name="'+ this.$field.dataset.paramName +'-name[]" value="'+ fileName +'"/>';
            this.$form.appendChild(child2);
        }
        // Otherwise, on error
        else if (response.status === 2) {
            this.$field.parentElement.parentElement.append(
                    '<div class="form__error">' +
                        response.messages +
                    '</div>'
            );
        }

        this.updateRemoveFileListeners();
    }

    init() {
        this.dropzone = new Dropzone(this.$field, {
            url: placeholders.baseUri + '/form/upload',
            clickable: this.$btnUpload,
            createImageThumbnails: false,
            addRemoveLinks: false,
            previewTemplate: '<div style="display: none;"></div>',
            //previewsContainer: $previewContainer[0],
            // Name of the field that will be POSTed with the
            // uploaded file(s)
            paramName: this.$field.dataset.paramName,
            maxFilesize: parseInt(this.$field.dataset.maxFilesize),
            uploadMultiple: this.$field.dataset.uploadMultiple === 'true',
            maxFiles: parseInt(this.$field.dataset.maxFiles),
            acceptedFiles: this.$field.dataset.acceptedFiles,
            params: {
                // We pass on the field's data-id, as we need it for
                // identification in the back end
                field : this.$field.dataset.id
            },
            init: function() {
                // Every time a file is chosen for uploading
                this.on("sending", function(file, xhr) {
                    // Add the current XSRF token to the headers
                    xhr.setRequestHeader(
                            'X-XSRF-TOKEN',
                            function() {
                                var c = document.cookie.split('; ');
                                var cookies = {};

                                for(let i=c.length -1 ; i>=0; i--){
                                    var C = c[i].split('=');
                                    cookies[C[0]] = C[1];
                                }

                                return decodeURIComponent(cookies['XSRF-TOKEN']);
                            }()
                    );

                });
            }
        });

        this.dropzone.on('totaluploadprogress', (progress) => {
            this.$progress.classList.add('file-upload__progress--active');
            this.$progressbar.style.width =  progress + '%';
            this.$progressLabel.innerHTML =  Math.round(progress) + '%';
        });

        // When we add a file to the queue
        this.dropzone.on('addedfile', () => {
            // Disable all the buttons
            this.$form.classList.add('form--disabled');
            this.$form.querySelector('[data-submit]').classList.add('button--disabled');
        });

        // Whenever a file is handled by the back end
        this.dropzone.on('success', (file, response) => {
            this.uploadSuccess(file.name, response);
        });
    }
}